import getSiteInfo from "@casino/client/utils/getSiteInfo";
import { getCookie } from "@workspace/cookies/browser";
import { LANGUAGE_COOKIE } from "@workspace/nextjs_utils/src/cookies/LANGUAGE_COOKIE";

const getLanguage = () => {
  const language = getCookie(LANGUAGE_COOKIE);
  const { defaultLang } = getSiteInfo();
  return language ?? defaultLang;
};

export default getLanguage;
